export type FieldTrimProps = {
  formData: any;
};
const fieldTrim = ({ formData }: FieldTrimProps) => {
  if (typeof formData !== "object") return formData;
  else {
    const newFormData = { ...formData };
    Object.keys(formData).forEach((key) => {
      if (typeof formData[key] === "string") {
        newFormData[key] = formData[key].trim();
      }
    });
    return newFormData;
  }
};

export default fieldTrim;
